import React from 'react';
import { useLanguage } from '../Providers/LanguageContext';
import styles from './AboutModal.module.css';

interface AboutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function AboutModal({ isOpen, onClose }: AboutModalProps) {
  const { t } = useLanguage();

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          ×
        </button>
        <h2 className={styles.title}>{t('about.title')}</h2>
        <div className={styles.content}>
          <p>{t('about.paragraph1')}</p>

          <div className={styles.separator}></div>

          <p>{t('about.paragraph2')}</p>

          <div className={styles.separator}></div>

          <p>{t('about.paragraph3')}</p>

          <div className={styles.separator}></div>

          <p>{t('about.paragraph4')}</p>
        </div>
      </div>
    </div>
  );
}

export default AboutModal;